import { jsxs, jsx } from 'react/jsx-runtime';
import { AnimatePresence } from 'framer-motion';
import { useExpandedFdocContext } from '../../../ExpandedFdoc/ExpandedFdocProvider.js';
import { Flex } from '@fabric-app/ui/components/Flex';
import { ForcedTheme } from '@fabric-app/ui/theme/ForcedTheme';
import MessageForm from '../../../../../assistant/components/Chatbot/MessageForm.js';
import MessagesList from '../../../../../assistant/components/Chatbot/MessageList.js';
import { MessagesProvider } from '../../../../../assistant/hooks/useChatbot.js';
import { useResourceDataContextSafe } from '../../../context/resourceDataContext.js';
import { cssVar } from '@fabric-app/ui/theme/variables';
import { styled } from 'styled-components';

const ExtraPanelTabAssistant = ({ commentInputVisible }) => {
  const { sidebarAnimateIn } = useExpandedFdocContext();
  const isInputVisible = commentInputVisible;
  const { resource } = useResourceDataContextSafe();
  return /* @__PURE__ */ jsxs(MessagesProvider, {
    chatAssistantOpen: true,
    expandedResourceId: resource.id,
    children: [
      /* @__PURE__ */ jsx(ForcedTheme, {
        colorScheme: "dark",
        asChild: true,
        children: /* @__PURE__ */ jsx(Container, {
          direction: "column",
          children: /* @__PURE__ */ jsx(MessagesList, {})
        })
      }),
      /* @__PURE__ */ jsx(AnimatePresence, {
        initial: sidebarAnimateIn,
        children: isInputVisible ? /* @__PURE__ */ jsx(MessageForm, {
          forceDark: true
        }) : null
      })
    ]
  });
};
const Container = styled(Flex).withConfig({
  displayName: "ExtraPanelTabAssistant__Container",
  componentId: "sc-91c62c2c-0"
})([
  `--fabric-color-bg-assistant:`,
  `;height:100%;position:relative;overflow:hidden;`
], cssVar["bg-expanded-resource-extra-panel"]);

export { ExtraPanelTabAssistant };
//# sourceMappingURL=ExtraPanelTabAssistant.js.map
